import moment from "moment"
export const displayDate = dateString => {
  const date = new Date(dateString)
  return moment(date).format("MMM DD, YYYY")
}
